<template lang="pug">
v-text-field.mr-2(
  placeholder='欄位名稱'
  :disabled='disabled'
  v-model.trim='value.label'
  :prefix='`${index + 1}.`'
  hide-details
  :rules='rules'
)
  template(slot='append-outer')
    v-btn.my-0.error--text(icon small slot='activator' @click.stop='remove'): v-icon close
  template(slot='append')
    template(v-if='!isMobile')
      v-chip(small color='pink lighten-1' text-color='white' v-if='value.isRequired ')
        | 必填
      v-chip(small color='blue' text-color='white' v-if='value.isMultiLine ')
        | 多行文字
    v-menu(top)
      v-btn.ma-0(slot='activator' icon small flat)
        v-icon fas fa-angle-down
      v-list(subheader)
        v-subheader 欄位選項
        v-list-tile(@click='set(`isRequired`, !value.isRequired)')
          v-list-tile-avatar
            ReadonlyCheckbox(:value='value.isRequired')
          v-list-tile-content
            v-list-tile-title 必填
        v-list-tile(@click='set(`isMultiLine`, !value.isMultiLine)')
          v-list-tile-avatar
            ReadonlyCheckbox(:value='value.isMultiLine')
          v-list-tile-content
            v-list-tile-title 多行文字
</template>

<script>
import ReadonlyCheckbox from '@/components/ReadonlyCheckbox.vue'

export default {
  name: 'CustomField',
  props: ['value', 'disabled', 'index'],
  data () {
    this.rules = [v => !!v || 'Custom field is required']
    return {}
  },
  methods: {
    remove () {
      this.$emit('remove')
    },
    set (key, value) {
      this.$set(this.value, key, value)
    },
  },
  watch: {
    value: {
      deep: true,
      handler () {},
    },
  },
  components: {
    ReadonlyCheckbox,
  },
}
</script>
